import styled, { css } from 'styled-components';
import { MButtonIconState } from './MButtonIcon.types';
import { baseVariables } from '@marriott/mi-ui-library';

const ICON_BUTTON_SIZE = '2rem';
const ICON_BUTTON_PADDING = baseVariables.border.borderRadius02;

const transparentStyles = css`
  background-color: var(--t-color-scrim-100, rgba(255, 255, 255, 0.52));
  backdrop-filter: blur(4px);
`;

const defaultStyles = css`
  background-color: var(--t-icon-btn-primary-bg-color, #eeeeee);
`;

export const ButtonIcon = styled.button<{ $state: MButtonIconState }>`
  --icon-color: var(--t-button-secondary-fg-color, ${baseVariables.color.base10});
  display: flex;
  align-items: center;
  justify-content: center;
  block-size: ${ICON_BUTTON_SIZE};
  inline-size: ${ICON_BUTTON_SIZE};
  padding: ${ICON_BUTTON_PADDING};
  border: none;
  border-radius: ${baseVariables.border.borderRadius02};
  cursor: pointer;
  box-sizing: border-box;
  color: var(--icon-color);

  ${({ $state }) => ($state === MButtonIconState.Transparent ? transparentStyles : defaultStyles)}

  &:hover:not(:disabled) {
    --icon-color: var(--t-button-secondary-hover-fg-color, ${baseVariables.color.base20});
    background-color: var(--t-icon-btn-hover-bg-color, #000000);
  }

  &:focus:not(:disabled) {
    outline: 2px solid -webkit-focus-ring-color;
  }

  &:disabled {
    opacity: 0.67;
    pointer-events: none;
  }

  .icon {
    color: var(--icon-color);
  }
`;
